module.exports = __webpack_public_path__ + "img/influencer_thumbnail-400x300.0ce8914d.jpg";